// Opaque, site-bound receipt only. Never put the buyer's email in URLs/storage.
export interface NoOrderReceipt { token: string; alreadyRegistered: boolean }
const key = (siteId: string) => `crm-no-order-receipt:${siteId}`
export const saveNoOrderReceipt = (siteId: string, receipt: NoOrderReceipt) => {
  try { window.sessionStorage.setItem(key(siteId), JSON.stringify(receipt)) } catch { /* History state is the fallback. */ }
}
export const readNoOrderReceipt = (siteId: string): NoOrderReceipt | null => {
  let receipt: NoOrderReceipt | null = null
  if (window.history.state?.noOrderSiteId === siteId) receipt = window.history.state.noOrderReceipt
  if (!receipt) {
    try { receipt = JSON.parse(window.sessionStorage.getItem(key(siteId)) || 'null') } catch { /* Storage may be disabled. */ }
  }
  return receipt && /^[0-9a-f-]{36}$/i.test(receipt.token || '') ? receipt : null
}
